module.exports = __webpack_public_path__ + "img/videoPoster.67df9da3.png";